import React from 'react';
import LabelClaro from './LabelClaro';

class ExpirationDateClaro extends React.Component{

    constructor(props){
        super(props);
        this.buildMonthCbo();
        this.buildYearCbo();
    }

    buildMonthCbo(){
        this.monthOptions = [];
        this.monthOptions.push(<option value="">MM</option>);
        let finalMonth = 12;
        let nString = "";
        for(let m = 1; m <= finalMonth; m++){
            nString = m > 9 ? "" + m: "0" + m;
            this.monthOptions.push(<option  value={nString}>{nString}  </option>);
        }
    }

    buildYearCbo(){
        this.yearOptions = [];
        let currentYear = new Date().getFullYear();
        this.yearOptions.push(<option value="-">AAAA</option>);
        for(let i = 0; i <= 10; i++){
            this.yearOptions.push(<option value={currentYear + i}>{currentYear + i}</option>);
        }
    }

    render(){
        let firstError = "";
        this.props.errors.map((error) => { if (error !== undefined){ firstError = error; return; } });
        return (
            <div className="form-group">
                <LabelClaro htmlFor={this.props.idElement} labelText={this.props.labelText} labelTip={this.props.labelTip} className={this.props.labelClassName} />
                <div className={this.props.monthDivClassName}>
                    <select defaultValue={this.props.valueM} name="expiryDate_MM" id="cboExpireDateMonth" className="form-control" onChange={this.props.onChange}>
                        {this.monthOptions}
                    </select>
                </div>
                <div className={this.props.yearDivClassName}>
                    <select  defaultValue={this.props.valueY} name="expiryDate_YY" id="cboExpireDateYear" className="form-control" onChange={this.props.onChange}>
                        {this.yearOptions}
                    </select>
                </div>
                <span className="col-lg-offset-4 col-md-offset-4 help-block error-wrapper error-invalid">
                    {firstError}
                </span>
            </div>
        );
    }

}

ExpirationDateClaro.defaultProps = {
    monthDivClassName:"date-mm col-lg-4 col-md-4 col-sm-6 col-xs-6",
    yearDivClassName:"date-yy col-lg-4 col-md-4 col-sm-6 col-xs-6",
    errorDivClassName:"col-lg-offset-4 col-md-offset-4 help-block error-wrapper error-invalid"

}

export default ExpirationDateClaro;